export function greetingTemplateModel() {
    return {
        textTranslations: {},
        isGlobal: false,
        enabled: true,
    };
}
